<template>
  <div id="errorPage" class="m-5 p-5">
    <h1>{{ $t('error:oops') | capitalize }}</h1>
    <h2>{{ $t('error:' + (code || $route.meta.code) + 'Message') | capitalize }}</h2>
    <h6>{{ $t('error:' + (code || $route.meta.code) + 'Error') | capitalize }}</h6>

    <ul class="list-unstyled mt-3">
      <li>{{ $t('error:links') | capitalize }}</li>
      <li class="ml-2"><router-link id="errorHomeLink" to="/">{{ $t('error:home') | capitalize }}</router-link></li>
      <li class="ml-2"><router-link id="errorAboutLink" to="/about">{{ $t('error:about') | capitalize }}</router-link></li>
      <li class="ml-2"><router-link id="errorGatewaysLink" to="/gateways">{{ $t('error:gateways') | capitalize }}</router-link></li>
      <li class="ml-2"><router-link id="errorEndDevicesLink" to="/end-devices">{{ $t('error:endDevices') | capitalize }}</router-link></li>
      <li class="ml-2"><router-link id="errorAlarmsLink" to="/alarms">{{ $t('error:alarms') | capitalize }}</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    code: {
      type: Number,
      default: null
    }
  }
}
</script>
